@let chartCurrentId = store.chartIdSg();
@let error =
  chartCurrentId &&
  store.treeEditorFeature.selectors
    .error({
      chartId: chartCurrentId,
    })
    .asSignal();
@let errorDescription = error?.toString();
@let hasData = hasDataSg();

<div class="atn-summit-org-chart">
  @if (error) {
    <div class="atn-summit-org-chart__empty-state-container">
      <div class="atn-summit-org-chart__empty-state-content">
        <atn-ds-empty-state
          [description]="errorDescription"
          layout="v"
          title="Something went wrong"
          type="error"
        />
      </div>
    </div>
  } @else if (!hasData) {
    <div class="atn-summit-org-chart__empty-state-container">
      <div class="atn-summit-org-chart__empty-state-content">
        <atn-ds-empty-state
          description="No data was found. Not what you expected? Try refreshing, check your source data, or contact support."
          layout="v"
          title="Nothing to see here!"
          type="no-data"
        />
      </div>
    </div>
  } @else {
    <div class="atn-summit-org-chart__main-panel">
      <atn-summit-org-chart-tools class="atn-summit-org-chart__tools" />
      <atn-summit-org-chart-graph (click)="graphClickHandler()" />
    </div>
    <atn-summit-org-chart-node-panel />
  }
</div>
